import { render, staticRenderFns } from "./UheaderDropdownAccnt.vue?vue&type=template&id=229a3056&scoped=true"
import script from "./UheaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./UheaderDropdownAccnt.vue?vue&type=script&lang=js"
import style0 from "./UheaderDropdownAccnt.vue?vue&type=style&index=0&id=229a3056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a3056",
  null
  
)

export default component.exports